import {Module, Mutation, VuexModule} from 'vuex-module-decorators';
import Store from './index';
import {RealTimeInfo} from "@/entity/RealTimeInfo";
import {UserInfoEntity} from "@/entity/UserInfoEntity";
import {CompanyInfo} from "@/entity/CompanyInfo";

@Module({
    store: Store,
    name: 'RealTimeInfoStore',
    dynamic: true,
})
export class RealTimeInfoStore extends VuexModule {
    public realInfos: Array<RealTimeInfo> = []
    public queryInfo: UserInfoEntity = new UserInfoEntity()
    public companyInfo: CompanyInfo = new CompanyInfo()

    @Mutation
    public setCurrentRealInfos(realInfos: Array<RealTimeInfo>) {
        this.realInfos=[]
        this.realInfos = realInfos
    }
    @Mutation
    public setQueryInfo(queryInfo: UserInfoEntity) {
        this.queryInfo = queryInfo
    }
    @Mutation
    public setCompanyInfo(companyInfo: CompanyInfo) {
        this.companyInfo = companyInfo
    }
}
